/* EVENTS */
export const GET_CATEGORY = "GET_CATEGORY"
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS"
export const GET_CATEGORY_FAIL = "GET_CATEGORY_FAIL"

export const GET_CATEGORY_DETAILS = "GET_CATEGORY_DETAILS"
export const GET_CATEGORY_DETAILS_SUCCESS = "GET_CATEGORY_DETAILS_SUCCESS"
export const GET_CATEGORY_DETAILS_FAIL = "GET_CATEGORY_DETAILS_FAIL"

export const ADD_NEW_CATEGORY = "ADD_NEW_CATEGORY"
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS"
export const ADD_CATEGORY_FAIL = "ADD_CATEGORY_FAIL"

export const UPDATE_CATEGORY = "UPDATE_CATEGORY"
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS"
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL"

export const DELETE_CATEGORY = "DELETE_CATEGORY"
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS"
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL"

export const ACTIVATE_CATEGORY = "ACTIVATE_CATEGORY"
export const ACTIVATE_CATEGORY_SUCCESS = "ACTIVATE_CATEGORY_SUCCESS"
export const ACTIVATE_CATEGORY_FAIL = "ACTIVATE_CATEGORY_FAIL"

export const DEACTIVATE_CATEGORY = "DEACTIVATE_CATEGORY"
export const DEACTIVATE_CATEGORY_SUCCESS = "DEACTIVATE_CATEGORY_SUCCESS"
export const DEACTIVATE_CATEGORY_FAIL = "DEACTIVATE_CATEGORY_FAIL"


export const RESET_CATEGORY_STATE = 'RESET_CATEGORY_STATE';
